module.exports = __webpack_public_path__ + "img/icon6.2427acb5.svg";